export default "__VITE_ASSET__4a41ec2d__"